import React, { Fragment, useEffect, useRef, useState, } from "react";
import { v4 as uuidv4 } from "uuid";
import { RawTooltip } from "./Tooltip";
export const EllipseContent = ({ children, tip, placement, lines = 1, }) => {
    const ref = useRef(null);
    const ellipseActive = useIsEllipseActive(ref, tip);
    const tipID = uuidv4();
    return (React.createElement(Fragment, null,
        placement !== "bottom" && ellipseActive && (React.createElement(RawTooltip, { content: tip, placement: placement, anchorId: `anchor_${tipID}` })),
        React.createElement("span", { id: `anchor_${tipID}`, className: "ellipse-content", "data-tip": true, "data-for": tipID, ref: ref, style: { WebkitLineClamp: lines, lineClamp: lines } }, children),
        placement === "bottom" && ellipseActive && (React.createElement(RawTooltip, { content: tip, placement: "bottom", anchorId: `anchor_${tipID}` }))));
};
export const EllipseWrapper = ({ children }) => (React.createElement("div", { style: {
        overflow: "hidden",
        display: "block",
    } }, children));
export function useIsEllipseActive(ref, tip) {
    const [ellipseActive, setEllipseActive] = useState(false);
    const isEllipsisActive = (e) => e.offsetWidth < e.scrollWidth;
    useEffect(() => {
        const component = ref.current;
        if (tip && component) {
            if (component.offsetHeight < component.scrollHeight ||
                component.offsetWidth < component.scrollWidth) {
                setEllipseActive(true);
            }
            ref.current && isEllipsisActive(ref.current) && setEllipseActive(true);
        }
    }, [ref.current]);
    return ellipseActive;
}
